
export interface DateProvider {
  now(): Date;
}


export const DEFAULT_DATE_PROVIDER = {
  now: () => new Date(),
};


export class TestDateProvider implements DateProvider {

  private current: Date;

  constructor(d: Date) {
    this.current = d;
  }

  now() {
    return new Date(this.current);
  }

  set(d: Date) {
    this.current = d;
  }

}
